import React, { useRef, useState } from "react";
import { Stars } from "./Stars";
const sampleComments = [{
  quote: "Me sorprendió la cantidad de fórmulas que trae. Arranqué probando con detergente y lavandina y se entiende bastante fácil.",
  author: "Mariela, Córdoba"
}, {
  quote: "Lo compre mas que nada porque quería hacer productos en casa y no sabia bien por donde arrancar. Me sirvió un montón la parte de costos.",
  author: "Carolina, Buenos Aires"
}, {
  quote: "Está bueno porque no tenés solamente las fórmulas y listo. También explica el paso a paso y hay bastante material para organizarte si querés vender.",
  author: "Romina, Santa Fe"
}, {
  quote: "Ya hice el detergente y el suavizante 🙌 me salieron bien. Ahora quiero probar algunos de los productos para autos.",
  author: "Laura, Mendoza"
}, {
  quote: "Pensé que iba a ser más complicado pero está bastante claro. La planilla de costos también suma mucho para no poner precios a ojo.",
  author: "Natalia, Buenos Aires"
}, {
  quote: "Me llegó todo enseguida. Hay muchísimo material, todavía no llegue a ver todo pero las fórmulas que probé hasta ahora me gustaron.",
  author: "Andrea, Entre Ríos"
}];
function CommentCard({
  quote,
  author
}: {
  quote: string;
  author: string;
}) {
  return <article className="flex min-h-[188px] flex-col rounded-2xl bg-white p-5 text-left shadow-[0_6px_18px_rgba(16,44,77,0.06)]" data-id="element-328" data-mp="2tuw0zu05colr">
      <Stars data-id="element-329" data-mp="2ozozmsucnw00" />
      <p className="mt-4 text-[14px] leading-[1.45] text-[#263754]" data-id="element-330" data-mp="2jxzq5hmrzqe1">“{quote}”</p>
      <p className="mt-auto pt-5 text-[13px] font-extrabold text-[#091a37]" data-id="element-331" data-mp="2k044yum7q9t3">— {author}</p>
    </article>;
}
export function TestimonialsShowcase() {
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const slideWidth = scroller.clientWidth * 0.86;
    setActiveIndex(Math.min(sampleComments.length - 1, Math.round(scroller.scrollLeft / slideWidth)));
  };
  const goToSlide = (index: number) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollTo({
      left: scroller.clientWidth * 0.86 * index,
      behavior: "smooth"
    });
  };
  return <section className="bg-[#f6f8fb] py-16 sm:py-24" data-id="element-332" data-mp="1cnopsfaokmoh">
      <div className="mx-auto max-w-7xl" data-id="element-333" data-mp="1cozpa2x3f89s">
        <div className="px-5 text-center sm:px-8 lg:px-10" data-id="element-334" data-mp="1hl6ozdywbnja">
          <Stars data-id="element-335" data-mp="1hnt5w47offe6" />
          <p className="mt-2 text-3xl font-extrabold tracking-[-0.06em] text-[#091a37]" data-id="element-336" data-mp="25buc36hdujqf">4.9/5</p>
          <p className="mt-1 text-sm font-bold text-[#657189]" data-id="element-337" data-mp="2aadyt93svzju">Puntuación promedio</p>
          <h2 className="mt-7 text-3xl font-extrabold tracking-[-0.055em] text-[#091a37] sm:text-4xl" data-id="element-338" data-mp="2aci33s5m30kn">Lo que dicen quienes ya accedieron</h2>
        </div>

        <div className="mt-10 lg:hidden" data-id="element-339" data-mp="20jj9twz66lup">
          <div ref={scrollerRef} onScroll={handleScroll} className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Comentarios de muestra, desplazables horizontalmente" data-id="element-340" data-mp="20ihq74438r1d">
            {sampleComments.map(comment => <div key={comment.author} className="w-[86%] shrink-0 snap-start" data-id="element-341" data-mp="hk39ftkia5md"><CommentCard {...comment} data-id="element-342" data-mp="cm1n8zrs9q6o" /></div>)}
          </div>
          <div className="mt-4 flex justify-center gap-1.5" aria-label="Selector de comentarios" data-id="element-343" data-mp="rbpt8eawtd0q">
            {sampleComments.map((comment, index) => <button type="button" key={comment.author} onClick={() => goToSlide(index)} aria-label={`Ver comentario ${index + 1}`} aria-current={index === activeIndex} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${index === activeIndex ? "w-4 bg-[#0077e8]" : "w-1.5 bg-[#b9c6d5]"}`} data-id="element-344" data-mp="me7hkg5icjp1" data-mpi={index} />)}
          </div>
        </div>

        <div className="mt-12 hidden grid-cols-3 gap-4 px-5 lg:grid lg:px-10" data-id="element-345" data-mp="3mmzi8303tpv">
          {sampleComments.map(comment => <CommentCard key={comment.author} {...comment} data-id="element-346" data-mp="1j2m2l4xrgzj9" />)}
        </div>
      </div>
    </section>;
}